import { StudyLearningJourney } from './StudyLearningJourney';
import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { z } from 'zod';
import { StudyShell } from './StudyShell';
import { WorkingCanvasPanel } from './WorkingCanvasPanel';

export function StudyNewWorkingPage() {
  const [params, setParams] = useSearchParams();
  const requested = z.string().uuid().safeParse(params.get('draft'));
  const [newQuestionId] = useState(() => crypto.randomUUID());
  const questionId = requested.success ? requested.data : newQuestionId;
  useEffect(() => {
    if (!requested.success) setParams({ draft: questionId }, { replace: true });
  }, [questionId, requested.success, setParams]);
  return (
    <StudyShell>
      <Link
        to="/learn/study/working"
        className="inline-flex min-h-11 items-center text-sm font-bold"
      >
        Back to My working
      </Link>
      <StudyLearningJourney active="working" />
      <h1 className="section-heading mt-3">My question</h1>
      <p className="mt-3 text-slate2">
        Write a question and record your steps. To submit a quiz answer, return to Assessment and
        fill in its answer boxes.
      </p>
      <p className="mt-2 text-xs text-slate2">
        Device drafts appear in My working on this browser. Account pages appear after “Saved”.
      </p>
      <WorkingCanvasPanel
        key={questionId}
        context={{ kind: 'free', question_id: questionId }}
        contextLabel="Mathematics · My question"
        startOpen
        startWithTutor
      />
    </StudyShell>
  );
}
